import React, { useState, useEffect } from "react";

const reviews = [
  {
    name: "Terex India Pvt. Ltd., Hosur",
    text: "Working with Samson and Associates was a seamless experience. Their team brought a deep understanding of architectural design and functionality, delivering a state-of-the-art training center that aligns perfectly with our vision. The blend of modern aesthetics and practical utility has made the facility a standout within our campus. Their professionalism, attention to detail, and timely execution have truly exceeded our expectations.",
    image: "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?ga=GA1.1.294819544.1712248997&semt=ais_hybrid&w=740",
  },
  {
    name: "Management, Kay Jay Forgings Pvt. Ltd., Hosur",
    text: "Delivered exceptional front elevation and architectural design work for our facility in Hosur. Their ability to translate our industrial requirements into a modern, visually striking design was impressive. The elevation truly reflects our brand identity while enhancing the functionality of the space. Their experience and dedication are clearly reflected in the quality of work they delivered.",
    image: "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?ga=GA1.1.294819544.1712248997&semt=ais_hybrid&w=740",
  },
  {
    name: "Team ASR, Dinnur, Hosur",
    text: "We entrusted Samson and Associates with the complete interior and exterior design of our facility in Dinnur, Hosur—and the results exceeded our expectations. From the façade to the finest interior detailing, every element was crafted with precision, elegance, and functionality in mind. Their design approach brought a fresh, modern look to our space while maintaining practical usability. We highly appreciate their commitment to quality and timely delivery.",
    image: "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?ga=GA1.1.294819544.1712248997&semt=ais_hybrid&w=740",
  },
  {
    name: "St. Sebastian Church Committee, Poolapatti, Dharmapuri",
    text: "Designing a place of worship requires sensitivity, creativity, and a deep understanding of spiritual space—and Samson and Associates delivered on all fronts. From the graceful exterior architecture to the serene, detailed interiors, their work on St. Sebastian Church reflects both reverence and modern craftsmanship. The church now stands as a landmark in Poolapatti, and we are grateful for their unwavering dedication and architectural brilliance.",
    image: "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?ga=GA1.1.294819544.1712248997&semt=ais_hybrid&w=740",
  },
];

const CustomerReviews = () => {
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const prevReview = () => {
    setIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  };

  const nextReview = () => {
    setIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
  };

  const getReview = (position) => {
    const newIndex = (index + position + reviews.length) % reviews.length;
    return reviews[newIndex];
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => setIsMobile(window.innerWidth <= 768);
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  return (
    <div
      style={{
        textAlign: "center",
        maxWidth: "1000px",
        margin: "50px auto",
        position: "relative",
        overflow: "hidden",
        marginBottom: "50px",
        padding: "0 10px",
      }}
    >
      {/* Heading */}
      <h2
        style={{
          fontSize: "2rem",
          fontWeight: "bold",
          marginBottom: "10px",
          textAlign: "left",
          marginTop: "100px",
          marginLeft: "20px",
        }}
      >
        What our <span style={{ color: "#5c0e14", fontSize: "50px" }}>Client</span> says
      </h2>

      {/* Description */}
      <p
        style={{
          color: "grey",
          fontSize: "1rem",
          marginBottom: "100px",
          textAlign: "left",
          marginLeft: "20px",
        }}
      >
        We are proud to work with some of the most innovative companies in the industry.
      </p>

      {/* Review Container */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          marginTop: "50px",
          gap: "20px",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {/* Left Blur */}
        {!isMobile && (
          <div
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              height: "100%",
              width: "30%",
              background: "linear-gradient(to right, #fff8f1, rgba(255,255,255,0))",
              zIndex: 2,
            }}
          ></div>
        )}

        {/* Left Review */}
        {!isMobile && (
          <div
            style={{
              background: "white",
              padding: "15px",
              borderRadius: "10px",
              boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)",
              transform: "scale(0.9)",
              opacity: 0.7,
              width: "30%",
              textAlign: "center",
              zIndex: 1,
            }}
          >
            <img
              src={getReview(-1).image}
              alt={getReview(-1).name}
              style={{ width: "50px", borderRadius: "50%", marginBottom: "10px" }}
            />
            <p style={{ fontSize: "0.9rem", fontStyle: "italic" }}>"{getReview(-1).text}"</p>
            <h4 style={{ marginTop: "10px", fontSize: "0.9rem", fontWeight: "bold" }}>
              - {getReview(-1).name}
            </h4>
          </div>
        )}

        {/* Main Review */}
        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
            transform: isMobile ? "scale(1)" : "scale(1.1)",
            width: isMobile ? "90%" : "40%",
            textAlign: "center",
            zIndex: 3,
          }}
        >
          <img
            src={reviews[index].image}
            alt={reviews[index].name}
            style={{ width: "60px", borderRadius: "50%", marginBottom: "10px" }}
          />
          <p style={{ fontSize: "clamp(0.9rem, 2.5vw, 1rem)", fontStyle: "italic" }}>
            "{reviews[index].text}"
          </p>
          <h4
            style={{
              marginTop: "10px",
              fontSize: "clamp(0.9rem, 2.5vw, 1rem)",
              fontWeight: "bold",
            }}
          >
            - {reviews[index].name}
          </h4>
        </div>

        {/* Right Review */}
        {!isMobile && (
          <div
            style={{
              background: "white",
              padding: "15px",
              borderRadius: "10px",
              boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)",
              transform: "scale(0.9)",
              opacity: 0.7,
              width: "30%",
              textAlign: "center",
              zIndex: 1,
            }}
          >
            <img
              src={getReview(1).image}
              alt={getReview(1).name}
              style={{ width: "50px", borderRadius: "50%", marginBottom: "10px" }}
            />
            <p style={{ fontSize: "0.9rem", fontStyle: "italic" }}>"{getReview(1).text}"</p>
            <h4 style={{ marginTop: "10px", fontSize: "0.9rem", fontWeight: "bold" }}>
              - {getReview(1).name}
            </h4>
          </div>
        )}

        {/* Right Blur */}
        {!isMobile && (
          <div
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              height: "100%",
              width: "30%",
              background: "linear-gradient(to left, #fff8f1, rgba(255,255,255,0))",
              zIndex: 2,
            }}
          ></div>
        )}
      </div>

      {/* Navigation Buttons */}
      <button
        onClick={prevReview}
        style={{
          position: "absolute",
          left: isMobile ? "10px" : "10px",
          top: isMobile ? "75%" : "70%",
          transform: "translateY(-50%)",
          fontSize: isMobile ? "30px" : "50px",
          cursor: "pointer",
          background: "transparent",
          border: "none",
          zIndex: 4,
        }}
      >
        {"‹"}
      </button>
      <button
        onClick={nextReview}
        style={{
          position: "absolute",
          right: isMobile ? "10px" : "10px",
          top: isMobile ? "75%" : "70%",
          transform: "translateY(-50%)",
          fontSize: isMobile ? "30px" : "50px",
          cursor: "pointer",
          background: "transparent",
          border: "none",
          zIndex: 4,
        }}
      >
        {"›"}
      </button>
    </div>
  );
};

export default CustomerReviews;
